import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './aiHandoffActionsShimmerComponent.css';

const AiHandoffActionsShimmerComponent = () => {
  return (
    <div className="et-ai-handoff-actions-shimmer-container">
      <div className="et-ai-handoff-actions-shimmer-buttons-wrap">
        <div className="et-ai-handoff-actions-shimmer-button">
          <ShimmerComponent />
        </div>
        <div className="et-ai-handoff-actions-shimmer-button">
          <ShimmerComponent />
        </div>
      </div>
    </div>
  );
};

export default AiHandoffActionsShimmerComponent;